import { configureStore } from '@reduxjs/toolkit'
import { authReducer } from './slices/authSlice'
import { dashboardUserReducer } from './slices/DashboardUserSlice'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'
import { searchUserReducer } from './slices/userSearchSlice'
import { searchEventReducer } from './slices/eventSearchSlice'

const persistConfig = {
  key: 'root',
  storage: storage,
  whitelist: ['auth', 'dashboardUser']
}

const rootReducer = combineReducers({
  auth: authReducer,
  dashboardUser: dashboardUserReducer,
  searchUser: searchUserReducer,
  searchEvent: searchEventReducer
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
